import React, { useEffect, useRef, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import * as echarts from 'echarts/core';
import { LineChart } from 'echarts/charts';
import { GridComponent, TooltipComponent, LegendComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([LineChart, GridComponent, TooltipComponent, LegendComponent, CanvasRenderer]);

export const LineChartReport = ({ report = [] }) => {
  const chartRef = useRef(null);
  const [option, setOption] = useState({});

  const colors = {
    interface: '#FDB462',
    api: '#FF4C6F',
    gridLines: '#ECE9F8'
  };

  useEffect(() => {
    if (!report || report.length === 0) return;

    const optionData = {
      backgroundColor: 'transparent',
      grid: {
        left: '2%',
        right: '2%',
        bottom: '15%',
        top: '10%',
        containLabel: true
      },
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        borderWidth: 0,
        shadowColor: 'rgba(0, 0, 0, 0.1)',
        shadowBlur: 10,
        textStyle: { color: '#666' }
      },
      legend: {
        show: true,
        bottom: 0,
        left: 'left',
        icon: 'roundRect',
        itemWidth: 15,
        itemHeight: 4,
        textStyle: { color: '#999', fontSize: 12 },
        data: ['Resposta da Interface', 'Resposta da API']
      },
      xAxis: {
        type: 'category',
        data: report.map(item => item.time),
        boundaryGap: false,
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { color: '#999', fontSize: 11 }
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}ms',
          color: '#999',
          fontSize: 11
        },
        splitLine: { lineStyle: { color: colors.gridLines } }
      },
      series: [
        {
          name: 'Resposta da Interface',
          type: 'line',
          data: report.map(item => item.interface),
          smooth: false,
          showSymbol: false,
          connectNulls: true,
          lineStyle: { width: 2, color: colors.interface },
          itemStyle: { color: colors.interface }
        },
        {
          name: 'Resposta da API',
          type: 'line',
          data: report.map(item => item.api),
          smooth: false,
          showSymbol: false,
          connectNulls: true,
          lineStyle: { width: 2, color: colors.api },
          itemStyle: { color: colors.api }
        }
      ]
    };

    setOption(optionData);
  }, [report]);

  return (
    <ReactECharts
      ref={chartRef}
      option={option}
      echarts={echarts}
      style={{ height: 350, width: '100%' }}
      notMerge={true}
    />
  );
};
